import Button, { ButtonColorTypes } from "../shared-components/Button";
import InputField from "../shared-components/InputField";
import { Modal } from "../shared-components/Modal";

type RecurNextRunEditFormProps = {
  setOpen: (open: boolean) => void;
  startDate: string;
  setStartDate: (start_date: string) => void;
  save: () => void;
};

const RecurNextRunEditForm = ({
  setOpen,
  startDate,
  setStartDate,
  save,
}: RecurNextRunEditFormProps) => {
  return (
    <Modal open={true} width="w-[600px]" onClose={() => setOpen(false)}>
      <InputField
        name="edit-start-date"
        value={startDate.split("T")[0]}
        placeholder=""
        label="Start Date *"
        type="date"
        handleChange={(e) => {
          let picked = new Date(e.target.value);
          if (!isNaN(picked.getTime())) {
            setStartDate(picked.toISOString());
          }
        }}
      />
      <div className="flex flex-row-reverse gap-4">
        <Button
          text="Submit"
          onClick={() => save()}
          colorType={ButtonColorTypes.primary}
        />
        <Button
          text="Cancel"
          onClick={() => setOpen(false)}
          colorType={ButtonColorTypes.cancel}
        />
      </div>
    </Modal>
  );
};

export default RecurNextRunEditForm;
